// Products.jsx - Hybrid Static + Dynamic Products with Razorpay Integration
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { 
  FaSearch, 
  FaLeaf, 
  FaStar,
  FaShoppingCart,
  FaCheckCircle,
  FaShieldAlt,
  FaTag,
  FaClock,
  FaTimes,
  FaCreditCard,
  FaWallet,
  FaMoneyBillWave,
  FaLock,
  FaGooglePay,
  FaSpinner,
  FaExclamationTriangle,
  FaFilter,
} from 'react-icons/fa';
import productVideo from '../video/terragoldproducatvideo.mp4';
import '../css/CareersPage.css';
import moringaImage from '../img/moringapowderimage.png';
import beetrootImage from '../img/beetrootpowderimage.png';
import onionImage from '../img/onionpowderimage.png';
import garlicImage from '../img/garllicpowderimage.png';

const API_BASE_URL = 'http://localhost:3009';

// ============================================================
// STATIC PRODUCTS (These 4 will always show)
// ============================================================
const STATIC_PRODUCTS = [
  {
    id: 1,
    name: 'Terra Gold Organic Moringa Powder',
    category: 'powders',
    price: 399,
    compare_price: 650,
    discount_percentage: 39,
    rating: 4.0,
    review_count: 1132,
    image: moringaImage,
    images: [moringaImage],
    brand: 'Terra Gold',
    stock: 2450,
    unit: 'kg',
    status: 'In Stock',
    is_featured: true,
    is_bestseller: true,
    is_new: false,
    is_fulfilled: true,
    is_returnable: false,
    cashback_percentage: 5,
    cashback_description: 'Get 5% back with Amazon Pay ICICI Bank credit card',
    offers: 'Save Extra with 3 offers',
    benefits: [
      '🌿 Nutrient-Rich Superfoods - Packed with essential vitamins, minerals, and antioxidants',
      '⚡ Boosts Energy & Stamina - Natural energy boost for daily activities',
      '❤️ Supports Heart Health - Promotes cardiovascular wellness',
      '🛡️ Enhances Immunity - Strengthen immune system naturally',
      '🌱 Aids Digestion & Gut Health - Promotes better digestion'
    ],
    use_by_date: '2028-03-01',
    storage_condition: 'Store in a cool, dry place',
    short_description: '100% Pure Superfood | Supports Immunity, Energy, Digestion, Heart Health',
    variants: [
      { variantValue: '200g (Pack of 1)', price: 399, compare_price: 650, stock: 1000, unit: 'Pack of 1' },
      { variantValue: '200g (Pack of 2)', price: 750, compare_price: 1300, stock: 800, unit: 'Pack of 2' },
      { variantValue: '500g (Pack of 1)', price: 899, compare_price: 1625, stock: 650, unit: 'Pack of 1' }
    ]
  },
  {
    id: 2,
    name: 'Terra Gold Organic Beetroot Powder',
    category: 'powders',
    price: 199,
    compare_price: 350,
    discount_percentage: 43,
    rating: 3.8,
    review_count: 194,
    image: beetrootImage,
    images: [beetrootImage],
    brand: 'Terra Gold',
    stock: 1800,
    unit: 'kg',
    status: 'In Stock',
    is_featured: true,
    is_bestseller: false,
    is_new: false,
    is_fulfilled: true,
    is_returnable: false,
    cashback_percentage: 5,
    cashback_description: 'Get 5% back with Amazon Pay ICICI Bank credit card',
    offers: 'Apply 2% coupon | Bank Offer: 10% Instant Discount up to INR 50',
    benefits: [
      '💆‍♀️ 100% Pure, Organic & Natural for Face Pack & Face Mask',
      '🥤 Edible & Nutrient-Rich - Safe for Drinking, Eating & Everyday Nutrition',
      '💪 Boost Performance – Natural Pre-Workout for Strength & Stamina',
      '💇‍♀️ Hair, Skin & Beauty Booster – Natural DIY Ingredient',
      '💄 Natural Lip & Skin Glow – For Pink Lips & Radiant Face',
      '🧘‍♀️ Inflammation Recovery & Muscle Repair – Fast Post-Workout Healing',
      '❤️ Cardiovascular Health & Anti-Aging Support'
    ],
    use_by_date: '2028-03-01',
    short_description: 'Natural Energy Pre-workout | Improve Heart Health | 100% Pure & Preservative-Free',
    variants: [
      { variantValue: '200g (Pack of 1)', price: 199, compare_price: 350, stock: 800, unit: 'Pack of 1' },
      { variantValue: '200g (Pack of 2)', price: 390, compare_price: 650, stock: 600, unit: 'Pack of 2' },
      { variantValue: '500g (Pack of 1)', price: 450, compare_price: 825, stock: 400, unit: 'Pack of 1' }
    ]
  },
  {
    id: 3,
    name: 'Terra Gold White Onion Powder',
    category: 'powders',
    price: 189,
    compare_price: 258,
    discount_percentage: 27,
    rating: 4.5,
    review_count: 23,
    image: onionImage,
    images: [onionImage],
    brand: 'Terra Gold',
    stock: 1500,
    unit: 'kg',
    status: 'In Stock',
    is_featured: false,
    is_bestseller: false,
    is_new: true,
    is_fulfilled: true,
    is_returnable: false,
    cashback_percentage: 5,
    cashback_description: 'Upto ₹5.00 cashback as Amazon Pay Balance',
    offers: 'Bank Offer: Upto ₹18.90 discount on SBI Debit Cards | Buy 2 or more and get 10% off',
    benefits: [
      '🧅 100% Natural Dehydrated Onion Powder',
      '🚫 No Preservatives or Additives',
      '👨‍🍳 Ready-to-Use Cooking Seasoning',
      '🇮🇳 Perfect for Indian Dishes',
      '🌿 Pure & Chemical-Free'
    ],
    use_by_date: '2028-03-01',
    short_description: 'No Preservatives, No Additives | Ready-to-Use Cooking Seasoning',
    variants: [
      { variantValue: '55g (Pack of 1)', price: 99, compare_price: 129, stock: 500, unit: 'Pack of 1' },
      { variantValue: '55g (Pack of 2)', price: 189, compare_price: 258, stock: 300, unit: 'Pack of 2' },
      { variantValue: '200g (Pack of 1)', price: 199, compare_price: 299, stock: 200, unit: 'Pack of 1' },
      { variantValue: '400g (Pack of 1)', price: 299, compare_price: 499, stock: 150, unit: 'Pack of 1' }
    ]
  },
  {
    id: 4,
    name: 'Terra Gold Garlic Powder',
    category: 'powders',
    price: 189,
    compare_price: 258,
    discount_percentage: 27,
    rating: 4.5,
    review_count: 23,
    image: garlicImage,
    images: [garlicImage],
    brand: 'Terra Gold',
    stock: 1200,
    unit: 'kg',
    status: 'In Stock',
    is_featured: false,
    is_bestseller: false,
    is_new: true,
    is_fulfilled: true,
    is_returnable: false,
    cashback_percentage: 5,
    cashback_description: 'Upto ₹5.00 cashback as Amazon Pay Balance',
    offers: 'Bank Offer: Upto ₹18.90 discount on SBI Debit Cards | Buy 2 or more and get 10% off',
    benefits: [
      '🧄 100% Natural Dehydrated Garlic Powder',
      '🚫 No Preservatives or Additives',
      '👨‍🍳 Ready-to-Use Cooking Seasoning',
      '🇮🇳 Perfect for Indian Dishes',
      '🌿 Pure & Chemical-Free'
    ],
    use_by_date: '2028-03-01',
    short_description: 'No Preservatives, No Additives | Ready-to-Use Cooking Seasoning',
    variants: [
      { variantValue: '55g (Pack of 1)', price: 99, compare_price: 129, stock: 500, unit: 'Pack of 1' },
      { variantValue: '55g (Pack of 2)', price: 189, compare_price: 258, stock: 300, unit: 'Pack of 2' },
      { variantValue: '200g (Pack of 1)', price: 199, compare_price: 299, stock: 200, unit: 'Pack of 1' },
      { variantValue: '400g (Pack of 1)', price: 299, compare_price: 499, stock: 150, unit: 'Pack of 1' }
    ]
  }
];

// Load Razorpay script
const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const Products = () => {
  const [staticProducts] = useState(STATIC_PRODUCTS);
  const [dynamicProducts, setDynamicProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [showAddToCartMessage, setShowAddToCartMessage] = useState(false);
  const [cartMessage, setCartMessage] = useState('');
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [categories, setCategories] = useState([
    { id: 'all', name: 'All Products', icon: <FaLeaf /> },
    { id: 'powders', name: 'Natural Powders', icon: <FaLeaf /> }
  ]);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    landmark: ''
  });

  // Fetch dynamic products from API
  const fetchDynamicProducts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE_URL}/api/products`, {
        credentials: 'include'
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();

      if (data.success) {
        // Filter out products that are already in static list (by name or SKU)
        const staticNames = STATIC_PRODUCTS.map(p => p.name.toLowerCase());
        const filteredDynamic = data.products.filter(p => 
          !staticNames.some(name => p.name.toLowerCase().includes(name.split(' ').slice(0, 3).join(' ')))
        );
        setDynamicProducts(filteredDynamic);
        
        // Add dynamic categories
        const dynamicCategories = filteredDynamic.map(p => p.category).filter(Boolean);
        const uniqueCategories = [...new Set(dynamicCategories)];
        const newCategories = uniqueCategories.map(cat => ({
          id: cat.toLowerCase().replace(/ /g, '-'),
          name: cat,
          icon: <FaLeaf />
        }));
        
        // Combine with existing categories
        setCategories(prev => {
          const existingIds = prev.map(c => c.id);
          const filteredNew = newCategories.filter(c => !existingIds.includes(c.id));
          return [...prev, ...filteredNew];
        });
      } else {
        setError(data.message || 'Failed to fetch products');
      }
    } catch (err) {
      console.error('Error fetching products:', err);
      setError('Unable to load additional products. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDynamicProducts();
    // Load Razorpay script when component mounts
    loadRazorpayScript();
  }, []);

  // Get all products (static + dynamic)
  const getAllProducts = () => {
    return [...staticProducts, ...dynamicProducts];
  };

  const productExists = (name) => {
    return staticProducts.some(p => p.name.toLowerCase().includes(name.toLowerCase()));
  };

  // Payment Methods
  const paymentMethods = [
    { id: 'razorpay', name: 'Card/UPI/NetBanking', icon: <FaCreditCard />, description: 'Pay securely via Razorpay' },
    { id: 'cod', name: 'Cash on Delivery', icon: <FaMoneyBillWave />, description: 'Pay when you receive the product' },
  ];

  // Filter and search
  const getFilteredProducts = () => {
    let filtered = getAllProducts();

    // Filter by category
    if (activeCategory !== 'all') {
      filtered = filtered.filter(p => {
        const catId = p.category?.toLowerCase().replace(/ /g, '-') || 'powders';
        return catId === activeCategory;
      });
    }

    // Filter by search
    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      filtered = filtered.filter(p => 
        p.name.toLowerCase().includes(search) ||
        p.category?.toLowerCase().includes(search)
      );
    }

    return filtered;
  };

  const filteredProducts = getFilteredProducts();

  // Split products into two columns
  const leftColumnProducts = filteredProducts.filter((_, index) => index % 2 === 0);
  const rightColumnProducts = filteredProducts.filter((_, index) => index % 2 === 1);

  // Generate a unique order ID
  const generateOrderId = () => {
    return `TG_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`;
  };

  // Handle Razorpay Payment
  const handleRazorpayPayment = async () => {
    setIsProcessingPayment(true);

    try {
      const amount = selectedVariant ? selectedVariant.price : selectedProduct.price;
      const orderId = generateOrderId();

      // Prepare order data
      const orderData = {
        orderId: orderId,
        amount: amount * 100, // Convert to paise
        currency: 'INR',
        productName: selectedProduct.name,
        productId: selectedProduct.id,
        variant: selectedVariant,
        customerDetails: formData,
        receipt: orderId,
        paymentMethod: 'razorpay'
      };

      // Create order on your backend
      const response = await fetch(`${API_BASE_URL}/api/create-razorpay-order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error('Failed to create order');
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || 'Failed to create order');
      }

      // Razorpay options
      const options = {
        key: data.key_id, // Your Razorpay Key ID from backend
        amount: data.amount,
        currency: data.currency,
        name: 'Terra Gold',
        description: selectedProduct.name,
        image: selectedProduct.image || 'https://terragold.in/logo.png',
        order_id: data.order_id,
        handler: function(response) {
          // Payment successful
          handlePaymentSuccess(response, orderData);
        },
        prefill: {
          name: formData.name,
          email: formData.email || `${formData.name.toLowerCase().replace(/ /g, '.')}@example.com`,
          contact: formData.phone,
        },
        notes: {
          product_name: selectedProduct.name,
          product_id: selectedProduct.id,
          variant: selectedVariant?.variantValue || 'Default',
          address: `${formData.address}, ${formData.city}, ${formData.state} - ${formData.pincode}`
        },
        theme: {
          color: '#2d6a4f',
        },
        modal: {
          ondismiss: function() {
            setIsProcessingPayment(false);
          }
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (error) {
      console.error('Payment error:', error);
      alert('Payment failed: ' + error.message);
      setIsProcessingPayment(false);
    }
  };

  // Handle payment success
  const handlePaymentSuccess = async (razorpayResponse, orderData) => {
    try {
      // Verify payment on your backend
      const verificationData = {
        razorpay_payment_id: razorpayResponse.razorpay_payment_id,
        razorpay_order_id: razorpayResponse.razorpay_order_id,
        razorpay_signature: razorpayResponse.razorpay_signature,
        orderData: orderData
      };

      const response = await fetch(`${API_BASE_URL}/api/verify-payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(verificationData),
        credentials: 'include'
      });

      const data = await response.json();

      if (data.success) {
        // Payment verified successfully
        alert(`Payment Successful!\nPayment ID: ${razorpayResponse.razorpay_payment_id}\nOrder ID: ${razorpayResponse.razorpay_order_id}`);
        closePaymentModal();
        // You can redirect to order confirmation page here
        // window.location.href = '/order-confirmation';
      } else {
        alert('Payment verification failed. Please contact support.');
      }
    } catch (error) {
      console.error('Verification error:', error);
      alert('Payment verification failed. Please contact support.');
    } finally {
      setIsProcessingPayment(false);
    }
  };

  // Handle COD order
  const handleCODOrder = () => {
    const orderData = {
      orderId: generateOrderId(),
      product: selectedProduct,
      variant: selectedVariant,
      paymentMethod: 'cod',
      customerDetails: formData,
      amount: selectedVariant ? selectedVariant.price : selectedProduct.price,
      status: 'pending'
    };

    // Save COD order to backend
    fetch(`${API_BASE_URL}/api/create-cod-order`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(orderData),
      credentials: 'include'
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        alert(`Order placed successfully!\nOrder ID: ${orderData.orderId}\nPayment Method: Cash on Delivery`);
        closePaymentModal();
      } else {
        alert('Failed to place order. Please try again.');
      }
    })
    .catch(error => {
      console.error('COD order error:', error);
      alert('Failed to place order. Please try again.');
    });
  };

  const handleBuyNow = (product, variant = null) => {
    setSelectedProduct(product);
    setSelectedVariant(variant);
    setShowPaymentModal(true);
    setSelectedPaymentMethod(null);
  };

  const handleAddToCart = (product, variant = null) => {
    const variantText = variant ? ` (${variant.variantValue})` : '';
    setCartMessage(`${product.name}${variantText} added to cart!`);
    setShowAddToCartMessage(true);
    setTimeout(() => {
      setShowAddToCartMessage(false);
    }, 3000);
  };

  const handlePaymentMethodSelect = (methodId) => {
    setSelectedPaymentMethod(methodId);
  };

  const handlePlaceOrder = () => {
    if (!selectedPaymentMethod) {
      alert('Please select a payment method');
      return;
    }

    // Validate form data
    if (!formData.name || !formData.phone || !formData.address || !formData.city || !formData.state || !formData.pincode) {
      alert('Please fill in all required delivery details');
      return;
    }

    // Validate phone number
    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      alert('Please enter a valid 10-digit phone number');
      return;
    }

    // Validate pincode
    if (!/^[1-9][0-9]{5}$/.test(formData.pincode)) {
      alert('Please enter a valid 6-digit pincode');
      return;
    }

    if (selectedPaymentMethod === 'razorpay') {
      handleRazorpayPayment();
    } else if (selectedPaymentMethod === 'cod') {
      handleCODOrder();
    }
  };

  const closePaymentModal = () => {
    setShowPaymentModal(false);
    setSelectedProduct(null);
    setSelectedVariant(null);
    setSelectedPaymentMethod(null);
    setIsProcessingPayment(false);
    setFormData({
      name: '',
      phone: '',
      email: '',
      address: '',
      city: '',
      state: '',
      pincode: '',
      landmark: ''
    });
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const getImageUrl = (product) => {
    if (product.image) return product.image;
    if (product.thumbnail) return product.thumbnail;
    if (product.images && product.images.length > 0) {
      try {
        const images = typeof product.images === 'string' ? JSON.parse(product.images) : product.images;
        return images[0] || 'https://via.placeholder.com/300x300?text=No+Image';
      } catch {
        return 'https://via.placeholder.com/300x300?text=No+Image';
      }
    }
    return 'https://via.placeholder.com/300x300?text=No+Image';
  };

  const getBenefits = (product) => {
    if (product.benefits) {
      if (Array.isArray(product.benefits)) return product.benefits;
      try {
        return JSON.parse(product.benefits);
      } catch {
        return [];
      }
    }
    return [];
  };

  const getVariants = (product) => {
    if (product.variants) return product.variants;
    return [];
  };

  // Render loading state
  if (loading && dynamicProducts.length === 0) {
    return (
      <div className="products-page">
        <div className="loading-container">
          <FaSpinner className="spinner" />
          <p>Loading products...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="products-page">
      {/* Hero Section */}
      <div className="products-hero">
        <video className="hero-video" autoPlay loop muted playsInline>
          <source src={productVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="products-hero-overlay"></div>
        <div className="products-hero-content">
          <motion.h1
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Our <span className="hero-gradient">Premium Products</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Discover nature's finest spices, powders, and blends - 100% pure and chemical-free
          </motion.p>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="products-search-bar"
          >
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </motion.div>
        </div>
      </div>

      {/* Categories Section */}
      <div className="products-categories">
        <div className="container">
          <div className="categories-wrapper">
            {categories.map((category) => (
              <motion.button
                key={category.id}
                className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <span className="category-icon">{category.icon}</span>
                <span className="category-name">{category.name}</span>
              </motion.button>
            ))}
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <div className="products-grid-section">
        <div className="container">
          <div className="products-header">
            <h2>
              {activeCategory === 'all' ? 'All Products' : categories.find(c => c.id === activeCategory)?.name}
            </h2>
            <p>Showing {filteredProducts.length} products</p>
          </div>

          <div className="products-grid-2col">
            <div className="products-column">
              {leftColumnProducts.map((product) => (
                <motion.div
                  key={product.id}
                  className="product-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5 }}
                  whileHover={{ y: -5 }}
                >
                  <ProductCard 
                    product={product}
                    getImageUrl={getImageUrl}
                    getBenefits={getBenefits}
                    getVariants={getVariants}
                    onBuyNow={handleBuyNow}
                    onAddToCart={handleAddToCart}
                    isStatic={staticProducts.some(p => p.id === product.id)}
                  />
                </motion.div>
              ))}
            </div>

            <div className="products-column">
              {rightColumnProducts.map((product) => (
                <motion.div
                  key={product.id}
                  className="product-card"
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5 }}
                  whileHover={{ y: -5 }}
                >
                  <ProductCard 
                    product={product}
                    getImageUrl={getImageUrl}
                    getBenefits={getBenefits}
                    getVariants={getVariants}
                    onBuyNow={handleBuyNow}
                    onAddToCart={handleAddToCart}
                    isStatic={staticProducts.some(p => p.id === product.id)}
                  />
                </motion.div>
              ))}
            </div>
          </div>

          {filteredProducts.length === 0 && (
            <div className="no-products-center">
              <p>No products found matching your search.</p>
            </div>
          )}
        </div>
      </div>

      {/* Add to Cart Toast */}
      <AnimatePresence>
        {showAddToCartMessage && (
          <motion.div 
            className="add-to-cart-toast"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.3 }}
          >
            <FaCheckCircle className="toast-icon" />
            <span>{cartMessage}</span>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Payment Modal */}
      <AnimatePresence>
        {showPaymentModal && selectedProduct && (
          <motion.div 
            className="payment-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closePaymentModal}
          >
            <motion.div 
              className="payment-modal"
              initial={{ scale: 0.9, y: 50 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 50 }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="payment-modal-header">
                <h2>Place Order</h2>
                <button className="close-modal-btn" onClick={closePaymentModal}>
                  <FaTimes />
                </button>
              </div>

              {/* Product Summary */}
              <div className="payment-product-summary">
                <img src={getImageUrl(selectedProduct)} alt={selectedProduct.name} />
                <div className="product-summary-details">
                  <h4>{selectedProduct.name}</h4>
                  <p className="summary-price">
                    ₹{selectedVariant ? selectedVariant.price : selectedProduct.price}
                  </p>
                  {selectedVariant && (
                    <p className="summary-variant">{selectedVariant.variantValue}</p>
                  )}
                </div>
              </div>

              {/* Customer Details Form */}
              <div className="payment-form-section">
                <h3>Delivery Details</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter your full name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Enter phone number"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email (optional)"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label>Delivery Address *</label>
                  <input
                    type="text"
                    name="address"
                    placeholder="Street address, building, apartment"
                    value={formData.address}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>City *</label>
                    <input
                      type="text"
                      name="city"
                      placeholder="City"
                      value={formData.city}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>State *</label>
                    <input
                      type="text"
                      name="state"
                      placeholder="State"
                      value={formData.state}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Pincode *</label>
                    <input
                      type="text"
                      name="pincode"
                      placeholder="Pincode"
                      value={formData.pincode}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Landmark</label>
                    <input
                      type="text"
                      name="landmark"
                      placeholder="Landmark (optional)"
                      value={formData.landmark}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              {/* Payment Methods */}
              <div className="payment-methods-section">
                <h3>Select Payment Method</h3>
                <div className="payment-methods-grid">
                  {paymentMethods.map((method) => (
                    <div
                      key={method.id}
                      className={`payment-method-card ${selectedPaymentMethod === method.id ? 'selected' : ''}`}
                      onClick={() => handlePaymentMethodSelect(method.id)}
                    >
                      <div className="payment-method-icon">{method.icon}</div>
                      <div className="payment-method-info">
                        <span className="payment-method-name">{method.name}</span>
                        <span className="payment-method-desc">{method.description}</span>
                      </div>
                      {selectedPaymentMethod === method.id && (
                        <FaCheckCircle className="payment-method-check" />
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Order Summary */}
              <div className="order-summary">
                <div className="summary-row">
                  <span>Subtotal</span>
                  <span>₹{selectedVariant ? selectedVariant.price : selectedProduct.price}</span>
                </div>
                <div className="summary-row">
                  <span>Delivery</span>
                  <span className="free-delivery">FREE</span>
                </div>
                <div className="summary-row total">
                  <span>Total</span>
                  <span>₹{selectedVariant ? selectedVariant.price : selectedProduct.price}</span>
                </div>
              </div>

              {/* Place Order Button */}
              <button 
                className="place-order-btn"
                onClick={handlePlaceOrder}
                disabled={
                  !selectedPaymentMethod || 
                  !formData.name || 
                  !formData.phone || 
                  !formData.address || 
                  !formData.city || 
                  !formData.state || 
                  !formData.pincode ||
                  isProcessingPayment
                }
              >
                {isProcessingPayment ? (
                  <>
                    <FaSpinner className="spinner" />
                    Processing...
                  </>
                ) : (
                  <>
                    <FaLock className="lock-icon" />
                    Place Order - ₹{selectedVariant ? selectedVariant.price : selectedProduct.price}
                  </>
                )}
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

// Product Card Component
const ProductCard = ({ product, getImageUrl, getBenefits, getVariants, onBuyNow, onAddToCart, isStatic }) => {
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [showAllBenefits, setShowAllBenefits] = useState(false);

  const benefits = getBenefits(product);
  const variants = getVariants(product);
  const imageUrl = getImageUrl(product);

  const discountPercentage = product.discount_percentage || 
    (product.compare_price && product.price ? 
      Math.round(((product.compare_price - product.price) / product.compare_price) * 100) : 0);

  const displayPrice = selectedVariant?.price || product.price;
  const displayComparePrice = selectedVariant?.compare_price || product.compare_price;

  return (
    <div className="product-card-inner">
      {isStatic && (
        <div className="static-badge">⭐ Featured</div>
      )}
      
      <div className="product-image-section">
        <div className="product-image">
          <img src={imageUrl} alt={product.name} />
          {discountPercentage > 0 && (
            <div className="discount-badge">-{discountPercentage}%</div>
          )}
          {product.is_featured && (
            <div className="top-brand-badge">Top Brand</div>
          )}
          {product.is_bestseller && (
            <div className="top-brand-badge bestseller">Bestseller</div>
          )}
          {product.is_new && (
            <div className="top-brand-badge new">New</div>
          )}
        </div>
      </div>

      <div className="product-details">
        <div className="product-brand">{product.category || 'Natural Powders'}</div>
        <h3 className="product-name">{product.name}</h3>
        
        <div className="product-rating">
          <div className="stars">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className={i < Math.floor(product.rating || 0) ? 'star filled' : 'star'} />
            ))}
          </div>
          <span className="rating-value">{product.rating || 0}</span>
          <span className="reviews">({product.review_count || 0})</span>
        </div>

        <div className="product-price-section">
          <div className="price-row">
            <span className="current-price">₹{displayPrice}</span>
            {displayComparePrice && displayComparePrice > displayPrice && (
              <>
                <span className="original-price">₹{displayComparePrice}</span>
                <span className="discount-text">-{discountPercentage}%</span>
              </>
            )}
          </div>
          {product.cost_per_unit && (
            <div className="price-per-unit">₹{product.cost_per_unit} per 100g</div>
          )}
        </div>

        {product.offers && (
          <div className="product-offers">
            <div className="offer-item">
              <FaTag className="offer-icon" />
              <span>{product.offers}</span>
            </div>
          </div>
        )}

        <div className="product-badges">
          {product.is_fulfilled !== false && (
            <span className="badge fulfilled"><FaCheckCircle /> Fulfilled</span>
          )}
          {product.is_returnable === false && (
            <span className="badge non-returnable"><FaShieldAlt /> Non-Returnable</span>
          )}
          {product.stock > 0 && (
            <span className="badge in-stock"><FaCheckCircle /> In Stock</span>
          )}
          {product.stock === 0 && (
            <span className="badge out-of-stock"><FaTimes /> Out of Stock</span>
          )}
        </div>

        {/* Variants */}
        {variants && variants.length > 0 && (
          <div className="product-variants">
            <span className="variants-label">Size:</span>
            <div className="variant-options">
              {variants.map((variant, idx) => (
                <button 
                  key={idx} 
                  className={`variant-btn ${selectedVariant === variant ? 'active' : ''}`}
                  onClick={() => setSelectedVariant(variant)}
                >
                  {variant.variantValue}
                  <span className="variant-price">₹{variant.price}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="product-description">
          <p>{product.short_description || product.description?.substring(0, 100) + '...'}</p>
        </div>

        {benefits && benefits.length > 0 && (
          <div className="product-benefits">
            {benefits.slice(0, showAllBenefits ? benefits.length : 3).map((benefit, idx) => (
              <div key={idx} className="benefit-item">
                <FaLeaf className="benefit-icon" />
                <span>{benefit}</span>
              </div>
            ))}
            {benefits.length > 3 && (
              <button 
                className="show-more-benefits"
                onClick={() => setShowAllBenefits(!showAllBenefits)}
              >
                {showAllBenefits ? 'Show Less' : `Show ${benefits.length - 3} More`}
              </button>
            )}
          </div>
        )}

        {product.use_by_date && (
          <div className="product-use-by">
            <FaClock className="use-by-icon" />
            <span>Use by: {new Date(product.use_by_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
          </div>
        )}

        {/* Actions */}
        <div className="product-actions">
          <button 
            className="add-to-cart-btn"
            onClick={() => onAddToCart(product, selectedVariant)}
            disabled={product.stock === 0}
          >
            <FaShoppingCart /> Add to Cart
          </button>
          <button 
            className="buy-now-btn"
            onClick={() => onBuyNow(product, selectedVariant)}
            disabled={product.stock === 0}
          >
            Buy Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default Products;